import { lazy } from 'react';

export const Login = lazy(() => import(/* webpackChunkName: 'login' */ './Login'));
export const Logout = lazy(() => import(/* webpackChunkName: 'login' */ './Logout'));
export const Callback = lazy(() => import(/* webpackChunkName: 'login' */ './Callback'));

export { default as FlowEntry } from './FlowEntry';
export { default as FlowPage } from './FlowPage';
export { default as Shop } from './Shop';

export const Dashboard = lazy(() => import(/* webpackChunkName: 'dashboard' */ './Dashboard'));
